import RankZone from '@/features/reports/rank-zone'
// import RelevancyReport from '@/features/reports/relevancy/RelevancyReport'
import KeywordRankingReport from '@/features/reports/keyword-ranking-report'
import AttributeReport from '@/features/reports/attribute/AttributeReport'
import UrlRankingReport from '@/features/reports/url-ranking-report'  
import ProductGridReportProgress from '@/features/reports/product-grid-report/Progress.page'
import ProductGridReportKeyword from '@/features/reports/product-grid-report/Keyword.page'
import ProductGridReport from '@/features/reports/product-grid-report'
import rankzoneRoutes from '@/features/reports/rank-zone/rank-zone.routes'

export default [
  {
    path: 'keyword-movement-report',
    name: 'keyword-movement-report',
    component: KeywordRankingReport,
    props: (route) => ({ filters: route.query.filters, modal: route.query.modal })
  },
  {
    path: 'url-movement-report',
    name: 'url-movement-report',
    component: UrlRankingReport,
    props: (route) => ({ filters: route.query.filters })
  },
  {
    path: 'product-grid-report',
    name: 'product-grid-report',
    redirect: { name: 'grids' },
  },
  {
    path: 'grids',
    name: 'grids',
    component: ProductGridReport,
    redirect: { name: 'grid-progress' },
    children: [
      {
        path: 'stores/progress',
        name: 'grid-progress',
        component: ProductGridReportProgress,
        props: (route) => ({ filters: route.query.filters })
      },
      {
        path: 'keywords/comparison',
        name: 'grid-keyword',
        component: ProductGridReportKeyword,
        props: (route) => ({ filters: route.query.filters })
      }
    ]
  },
  {
    path: 'rank-zone',
    name: 'rankzone',
    component: RankZone,
    redirect: { name: 'Overview' },
    props: (route) => ({ advancedFilters: route.query.advancedFilters }),
    children: [
      ...rankzoneRoutes
    ]
  },
  { path: 'attribute',
    name: 'attribute',
    component: AttributeReport,
    props: (route) => ({ advancedFilters: route.query.advancedFilters })
  },
  // { path: 'relevancy',
  //   name: 'relevancy',
  //   component: RelevancyReport
  // }
]
